import { BaseDto } from '@/shared/dtos/base-dto';

export class centro_trabajo extends BaseDto {
    public nombre !: string;
    public notas !: string;
    public id_datos_empresa!:number;
 } 
